document.addEventListener('DOMContentLoaded', () => {

  const mainSearchDesktop = document.querySelector('header input#desktop')
  const mainSearchMobile = document.querySelector('header input#searchbar--mobile')
  const greenLitWords = 'return,returns,size,sizes,size chart,sizing guide,size guide sizing,gift,gifts,exchange,exchanges,discount,discounts,code,codes,promo,promos,issue,issues,instructions,care,delivery,shipping,cancel,refer,payment,payments,fraud,subscription,subscriptions,wholesale'
  const searchFormDesktop = document.querySelector('.desktop-only--header .searchbar__form')
  const searchFormMobile = document.querySelector('.mobile-nav__search .searchbar__form')

  if(!mainSearchDesktop || !mainSearchMobile) return

  mainSearchDesktop.addEventListener('input', (e) => {
    if(!checkForGreenlitWord(e.target.value)) {
      document.querySelector('.desktop .faq-inserted-suggestion')?.remove()
      document.querySelector('.desktop .greenlit-returns')?.remove()
      return
    }
    insertFAQSuggestion(e.target.value, 'desktop')
  })

  mainSearchMobile.addEventListener('input', (e) => {
    if(!checkForGreenlitWord(e.target.value)) {
      document.querySelector('.mobile .faq-inserted-suggestion')?.remove()
      document.querySelector('.mobile .greenlit-returns')?.remove()
      return
    }
    insertFAQSuggestion(e.target.value, 'mobile')
  })

  // pre

  searchFormDesktop.addEventListener('submit', (e) => {
    e.preventDefault()
    if(!e.target.querySelector('input#desktop').value === '' || !e.target.classList.contains('no-results--dont-submit')) {
      window.location.href = `${Shopify.routes.root}search?q=${e.target.querySelector('input#desktop').value}&type=product`
    }
  })

  searchFormMobile.addEventListener('submit', (e) => {
    if(e.target.querySelector('header input#searchbar--mobile').value === '' || e.target.classList.contains('no-results--dont-submit')) {
      e.preventDefault()
    }
  })

  function checkForGreenlitWord(query) {

    const wordArray = greenLitWords.split(',')

    for (let word of wordArray) {
      // Create a new RegExp object, adding word boundaries to match the whole word
      const regex = new RegExp(`\\b${word}\\b`, 'i')

      // Test the regex against the string
      if (regex.test(query)) {
        return true
      }
    }

    return false

  }

  function insertFAQSuggestion(query, device) {

    if(document.querySelector('.faq-inserted-suggestion')) return

    // console.log(`bulding for query: ${query} on ${device}`)

    // some of these variables could be customizble via the theme editor / settings
    // in the future, like search text and the target url for the faq page

    const searchText = 'Need more help? Search our FAQ page'
    const searchResultsDesktop = document.querySelector('.desktop .instant-search-results')
    const searchResultsMobile = document.querySelector('.mobile .instant-search-results')
    const url = new URL(`${document.location.origin}/pages/help-center`)

    url.searchParams.append('faq-helper', query)

    const faqPageLink = url.toString()

    const anchor = document.createElement('a')

    let htmlString = `
      <div class="text-center green-lit-word-found">
        ${searchText}
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='35'
          height='35'
          viewBox='0 0 24 24'
          fill='none'
          stroke="#53433A;"
        >
          fill='none'
          <path d="M3 12H21M21 12L14 19M21 12L14 5" stroke="#53433A;" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    `

    anchor.setAttribute('href', faqPageLink)
    anchor.classList.add('faq-inserted-suggestion')
    anchor.innerHTML = htmlString


      //  HARD CODED SPECIAL STRING LISTENERS 

      // return / returns

      const returnsRegex = /\b(return|returns)\b/gi
    
      if(returnsRegex.test(query)){

        console.log('ADDING SPECIAL RETURN LINKS')

        const returnEl = document.createElement('div')

        htmlString = `
          <div class="text-center green-lit-word-found greenlit-returns">
            Tying to make a return? Start here for: 
              <a href='/pages/returns-portal/'>US Returns</a>
              <a href='/pages/gift-returns/'>US Gift Returns</a>
              <a href='/pages/international-returns'>International Returns</a>
          </div>
        `
        returnEl.innerHTML = htmlString

        device === 'desktop' ? searchResultsDesktop.prepend(returnEl) : searchResultsMobile.prepend(returnEl)
      }

    device === 'desktop' ? searchResultsDesktop.prepend(anchor) : searchResultsMobile.prepend(anchor)
  }


})
